import React from "react";

function SvgIcMapPoi044(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M24 24.991v1c0 .95-1.354.998-1.49 1h-4.509v-1H22.5c.458 0 .497-.42.5-.49v-.51h1zM6.71 22.47l3.184 3.18c.325.327.651.05.7.006l.006-.006.354-.354.706.708-.706.707c-.676.676-1.676-.264-1.761-.347l-.006-.006-3.182-3.182.706-.706zm4.393-13.452h7.962c1.906 0 2.771 1.023 2.962 1.983.157.782-.18 1.635-.647 1.994l-.095.065-3.119 2.918 1.92 1.918c.369.37.714.713.852.85l.064.064v5.023c0 .626-.378 1.16-1.005 1.16-.585 0-.953-.465-1-1.036l-.005-.124v-4.018l-3.678-2.895a1.769 1.769 0 01-.759-1.451c0-.54.248-.892.647-1.333l.138-.15 2.631-3.051h-6.868c-1.389 0-1.435-1.791-.139-1.91l.14-.007h7.961zm2.855 8.527l1.414 1.414-4.663 4.663a.986.986 0 01-.751.359c-.552 0-1-.449-1-1 0-.272.11-.517.286-.697l-.013-.012 4.727-4.727zM24 6a2 2 0 110 4 2 2 0 010-4zm-4.925 3.016l-.01.001h-.01.02z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi044;
